import Layout from '@/layout'

const route = {
  path: '/copyiaarouter',
  component: Layout,
  redirect: '/copyiaarouter/index',
  alwaysShow: true, // will always show the root menu
  name: 'releaseGroup',
  meta: {
    title: 'IAA素材报表',
    icon: 'IAA',
    roles: [
      'iaaMaterialReport'
    ]
  },
  children: [

    {
      path: '/iaadepartment/index',
      component: () => import('@/views/iaadepartment/index.vue'),
      name: 'Iaadepartment',
      meta: {
        title: '部门管理',
        icon: 'component',
        roles: [
          'iaaMaterialReport.department' // 已修改权限
        ]
      }
    },
    {
      path: '/iaapitcher/index',
      component: () => import('@/views/iaapitcher/index.vue'),
      name: 'Iaapitcher',
      meta: {
        title: '绑定关系管理',
        icon: 'component',
        roles: [
          'iaaMaterialReport.bindRelation'
        ]
      }
    }, {
      path: '/placement/index',
      component: () => import('@/views/placement/index.vue'),
      name: 'Placement',
      meta: {
        title: '投放位置管理',
        icon: 'component',
        roles: [
          'iaaMaterialReport.position'
        ]
      }
    }, {
      path: '/iaareturne/index',
      component: () => import('@/views/iaareturne/index.vue'),
      name: 'Iaareturne',
      meta: {
        title: 'IAA回收',
        icon: 'component',
        roles: [
          'iaaMaterialReport.report.recyclingList.group'
        ]
      }
    }, {
      path: '/iaapitchernew/index',
      component: () => import('@/views/iaapitchernew/index.vue'),
      name: 'Iaapitchernew',
      meta: {
        title: '投手数据',
        icon: 'component',
        roles: [
          'iaaMaterialReport.report.pitcherList.group'
        ]
      }
    }, {
      path: '/newtoyusahwr/index',
      component: () => import('@/views/newtoyusahwr/index.vue'),
      name: 'newtoyusahwr',
      meta: {
        title: '投手数据/iAA回收',
        icon: 'component',
        roles: [
          'iaaMaterialReport.report.mergeShow.group'
        ]
      }
    }, {
      path: '/iaapitcherEarningsRank/index',
      component: () => import('@/views/iaapitcherEarningsRank/index.vue'),
      name: 'IaapitcherEarningsRank',
      meta: {
        title: '投手收益排行',
        icon: 'component',
        roles: [
          'iaaMaterialReport.report.pitcherEarningsRank.group'
        ]
      }
    }, {
      path: '/iaabigboard/index',
      component: () => import('@/views/iaabigboard/index.vue'),
      name: 'Iaabigboard',
      meta: {
        title: '大看板',
        icon: 'component',
        roles: [
          'iaaMaterialReport.report.bigDataDashboard.group'
        ]
      }
    }, {
      path: '/iaadatareport/index',
      component: () => import('@/views/iaadatareport/index.vue'),
      name: 'Iaadatareport',
      meta: {
        title: '素材报表（仅消耗）',
        icon: 'component',
        roles: [
          'iaaMaterialReport.report.costList.group'
        ]
      }
    },
    {
      path: '/pitcheraccount/index',
      component: () => import('@/views/pitcheraccount/index.vue'),
      name: 'Placement',
      meta: {
        title: '投手账户',
        icon: 'component',
        roles: [
          'iaaMaterialReport.report.pitcherAccount.group'
        ]
      }
    },
    {
      path: '/massive/index',
      component: () => import('@/views/massive/index.vue'),
      name: 'copyQueue',
      meta: {
        title: '巨量数据',
        icon: 'component',
        roles: [
          'iaaMaterialReport.report.ocean.group'
        ]
      }
    },
    {
      path: '/iaapeoplelist/index',
      component: () => import('@/views/iaapeoplelist/index.vue'),
      name: 'Iaapeoplelist',
      meta: {
        title: '投手详情',
        icon: 'component',
        noCache: true,
        roles: [
          'iaaMaterialReport.report.pitcherEarningsRank.group'
        ]
      },
      hidden: true
    }
  ]
}

export default route
